import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const FeettoMm = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertFeetToMm = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 5, 6.25).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const mmValue = feetValue * 304.8; // 1 foot = 304.8 millimeters
        setOutputValue(mmValue.toFixed(6)); // Limit output to 6 decimal places
    };







      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/mm-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to MM Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to mm using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
              icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
              title="Feet To MM Converter"
              subTitle="Effortlessly Convert Feet To MM for Accurate Measurements"
            />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToMm}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>MM Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
    <div className={styles.contentContainer}>
      <p>The Feet to Millimeters Converter is an essential tool for engineers, architects, DIYers, and students. It allows you to convert feet (ft) into millimeters (mm) quickly and precisely. Whether you're working on detailed blueprints, creating technical drawings, or measuring materials, this converter ensures perfect scaling across imperial and metric systems.</p>
      <p>This tool is ideal for global projects where millimeter-level accuracy is needed.</p>
      <h3>What Are Feet and Millimetres?</h3>
      <p><b>Feet (ft): </b> An imperial unit commonly used in the U.S. and U.K. to measure height, depth, and distance. <br />1 foot = 12 inches = 0.3048 meters</p>
      <p><b>Millimetres (mm): </b>A metric unit used for precise, small-scale measurements. <br />  1 mm = 0.001 meters</p>
      <p><b>Conversion Formula: </b>1 foot = 304.8 millimeters</p>
      <h3>Why Convert Feet to Millimetres?</h3>
      <ul>
        <li><b>Precision:</b> MM allows for very fine, exact measurements perfect for machining and design.</li>
        <li><b>Standardization:</b> Metric units are used globally in science, engineering, and manufacturing.</li>
        <li><b>Detailing:</b> Millimeters give cleaner, decimal-free values in precise drawings.</li>
      </ul>
      <h3>How to Use the Feet to MM Converter</h3>
      <ol>
        <li><b>Input Feet Value:</b> Enter the length in feet.</li>
        <li><b>Click Convert:</b> Instantly receive the equivalent value in millimetres.</li>
        <li><b>Copy the MM Result:</b> Use the output in CAD software, blueprints, or production specs.</li>
      </ol>
      <h3>Conversion Examples:</h3>
      <ul>
        <li>1 ft → 304.8 mm</li>
        <li>2.5 ft → 762 mm</li>
        <li>5 ft → 1,524 mm</li>
        <li>6.2 ft → 1,889.76 mm</li>
      </ul>
      <h3>Benefits of Using Feet to MM Converter</h3>
      <ul>
        <li><b>Fast & Accurate:</b> Converts using the standard formula no need for calculators.</li>
        <li><b>Time-Saving:</b> Saves effort when working with unit-specific tools or documents.</li>
        <li><b>Beginner-Friendly:</b> Easy to use, no math skills required.</li>
      </ul>
      <h3>Who Should Use This Tool?</h3>
      <p>This converter is ideal for anyone needing precision in a metric-based workflow:</p>
      <ul>
        <li>Mechanical & Civil Engineers</li>
        <li>Interior Designers & Architects</li>
        <li>Carpenters & Fabricators</li>
        <li>Teachers, Students & Hobbyists</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoMm;
